import React, { useState } from "react"
import { faCloud, faStar } from "@fortawesome/free-solid-svg-icons"

import Button from "react-bootstrap/Button"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Modal from "react-bootstrap/Modal"
import PropTypes from "prop-types"
import { RaffleTypes } from "components/layout-cekilis"
import ReCAPTCHA from "react-google-recaptcha"
import ShareIcons from "./share-icons"
import StarRating from "react-star-rating-component"
import { saveRaffle } from "utils/api"
import useTranslations from "components/use-translations"

export default function ShareButton({
  participants,
  winners,
  reserveWinners = [],
  type = RaffleTypes.Hizli,
  buttonText,
}) {
  const {
    cekilis: {
      cekilisSonucunuKaydet,
      cekilisiYapan,
      zorunluDegil,
      aciklama,
      aciklamaPlaceholder,
      cekilisDeneyiminizNasildi,
      robotDegilsinizdirAmaEminOlalim,
      cekilisiKaydet,
      iptal,
      cekilisSonucunuKaydetvePaylas,
      lutfenGuvenlikTamamlayin,
    },
  } = useTranslations()
  const [show, setShow] = useState(false)
  const [shareId, setShareId] = useState("")
  const [rating, setRating] = useState(null)

  const [captchaNeeded, setCaptchaNeeded] = useState(true)
  const [CaptchaProblem, setCaptchaProblem] = useState(false)

  const [creator, setCreator] = useState("")
  const [description, setDescription] = useState("")

  const handleClose = () => setShow(false)
  const handleShow = () => {
    setDescription("")
    setCreator("")
    setRating(null)
    setShow(true)
  }

  const save = () => {
    if (captchaNeeded) {
      setCaptchaProblem(true)
      return
    }
    if (participants.length > 8000) {
      alert("Bu kadar fazla katılımcıyı kayıt edemiyoruz")
      return
    }
    saveRaffle(
      creator,
      description,
      rating,
      type,
      participants,
      winners,
      reserveWinners
    )
      .then(response => response.text())
      .then(text => {
        setShareId(text)
      })
    handleClose()
  }
  return (
    <>
      {shareId && <ShareIcons shareId={shareId} />}
      {!shareId && (
        <Button
          variant="success"
          className="text-center w-100"
          onClick={handleShow}
        >
          <FontAwesomeIcon icon={faCloud} />
          <span>{buttonText || cekilisSonucunuKaydetvePaylas}</span>
        </Button>
      )}

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{cekilisSonucunuKaydet}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form-group mt-1  mb-0">
            <label
              className="text-dark  col-form-label-sm mb-0"
              htmlFor="creator"
            >
              {cekilisiYapan} ({zorunluDegil})
            </label>
            <div className="form-row align-items-center">
              <div className="col-auto ">
                <input
                  type="text"
                  id="creator"
                  value={creator}
                  onChange={e => setCreator(e.target.value)}
                  placeholder="@someone"
                  className="form-control  form-control-sm"
                />
              </div>
            </div>
          </div>
          <div className="form-group mt-1  mb-0">
            <label
              className="text-dark  col-form-label-sm mb-0"
              htmlFor="description"
            >
              {aciklama} ({zorunluDegil})
            </label>
            <div className="form-row align-items-center">
              <div className="col-auto w-100 ">
                <textarea
                  id="description"
                  value={description}
                  onChange={e => setDescription(e.target.value)}
                  placeholder={aciklamaPlaceholder}
                  rows="3"
                  className="form-control"
                />
              </div>
            </div>
          </div>
          <div className="form-group mt-3  mb-0">
            <label className="text-dark  col-form-label-sm mb-0">
              {cekilisDeneyiminizNasildi}
            </label>
            <div className="form-row align-items-center">
              <div className="col-auto w-100 ">
                <StarRating
                  name="rate1"
                  value={rating}
                  renderStarIcon={() => (
                    <span style={{ fontSize: 32 }}>
                      <FontAwesomeIcon icon={faStar} />
                    </span>
                  )}
                  onStarClick={nextValue => setRating(nextValue)}
                />
              </div>
            </div>
          </div>
          <div className="form-group mt-1  mb-0">
            <label className="text-dark  col-form-label-sm mb-0">
              {robotDegilsinizdirAmaEminOlalim}
            </label>
            <div className="form-row align-items-center">
              <div className="col-auto w-100 ">
                <ReCAPTCHA
                  sitekey="6Lc7BhUUAAAAADkjO0X7zGJDkreDtWF0ltlbeMcZ"
                  onChange={() => {
                    setCaptchaProblem(false)
                    setCaptchaNeeded(false)
                  }}
                  onExpired={() => setCaptchaNeeded(true)}
                  onErrored={() => setCaptchaNeeded(true)}
                />
                {CaptchaProblem && (
                  <small className="text-danger">
                    {lutfenGuvenlikTamamlayin}
                  </small>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={handleClose}>
            <span>{iptal}</span>
          </Button>
          <Button variant="success" onClick={save}>
            <FontAwesomeIcon icon={faCloud} className="mr-2" />
            <span>{cekilisiKaydet}</span>
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

ShareButton.propTypes = {
  type: PropTypes.number,
  participants: PropTypes.arrayOf(PropTypes.string).isRequired,
  winners: PropTypes.arrayOf(PropTypes.string).isRequired,
  reserveWinners: PropTypes.arrayOf(PropTypes.string),
  buttonText: PropTypes.string,
}
